var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GGGroup', {
    attrs: {
      "prop": _vm.data.template.prop,
      "enable-factoid": !!_vm.data.factoid,
      "order": _vm.data.factoid && _vm.data.factoid.align
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('GGRowSlider', {
          staticClass: "row-slider_news",
          attrs: {
            "list": _vm.list,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var el = _ref.el;
              return [_c('GGNewsCard', {
                attrs: {
                  "data": el
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }